import { MyEntryResultCard } from "@/components/PredictionMarket/MyEntryResultCard";
import { RecentResultCard } from "@/components/PredictionMarket/RecentResultCard";
import { Skeleton } from "@/components/ui/skeleton";
import { useGetPredictionMarketMyResults } from "@/hooks/predictionMarket/useGetPredictionMarketMyResults";
import { useGetPredictionMarketRecentResults } from "@/hooks/predictionMarket/useGetPredictionMarketRecentResults";
import { useHandleError } from "@/hooks/useHandleError";
import { ThumbaIcon } from "@roman/shared/components/Icons";
import { Link } from "react-router-dom";
import { LoadingSpinner } from "../Rounds";

export const MyPredictionMarketResultPage = () => {
  return (
    <>
      <div className="w-full bg-blue">
        <MyResults />

        {/* Don't need it for now */}
        {/* <RecentResults /> */}
      </div>
    </>
  );
};

const MyResults = () => {
  const { predictionMarketMyResults, isLoading } = useGetPredictionMarketMyResults({
    swrOptions: {
      onError: useHandleError("マイリザルトの取得に失敗しました"),
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  });

  if (!isLoading && !predictionMarketMyResults.length) {
    return <NoResultData />;
  }

  return (
    <>
      <div className="w-full bg-blue">
        <h1 className="text-xl font-bold py-2 px-5 w-full">結果</h1>
        <div className="px-5 pt-2 pb-5">
          <h2 className="text-lg font-medium">あなたの結果</h2>
          <div className="flex flex-col gap-5 py-2">
            {isLoading && Array.from({ length: 3 }).map((_, index) => <LoadingSkeleton key={index} />)}

            {predictionMarketMyResults.map((predictionMarketMyResult) => (
              <MyEntryResultCard
                key={predictionMarketMyResult.id}
                predictionMarketMyResult={predictionMarketMyResult}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

//  Don't need it for now
export const RecentResults = () => {
  const { predictionMarketRecentResults, isLoading } = useGetPredictionMarketRecentResults({
    swrOptions: {
      onError: useHandleError("マイリザルトの取得に失敗しました"),
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="px-4 pt-4 pb-5 bg-white">
      <h2 className="text-lg font-medium">最近の結果</h2>
      <div className="flex flex-col gap-5 py-2">
        {!isLoading && !predictionMarketRecentResults.length && <div className="text-xs">結果がありません</div>}
        {predictionMarketRecentResults.map((result) => (
          <RecentResultCard key={result.id} predictionMarketRecentResult={result} />
        ))}
      </div>
    </div>
  );
};

export const NoResultData = () => {
  return (
    <div className="h-screen p-4 bg-disabled">
      <div className="w-full text-xl font-bold text-white">結果</div>

      <div className="flex flex-col justify-center items-center">
        <div className="pt-8 text-white">
          <ThumbaIcon className="w-[170px] h-[140px] opacity-50" />
        </div>
        <div className="flex justify-center items-center text-sm text-center text-white font-medium py-4 px-4">
          あなたがエントリーしたクイズで
          <br />
          結果が確認できるクイズはありません。
        </div>
        <Link to="/prediction-market" className="flex justify-center items-center">
          <button
            type="button"
            className="py-3 px-5 border border-primary text-primary font-bold bg-white rounded-lg whitespace-nowrap"
          >
            追加のクイズに答えて賞金を獲得する
          </button>
        </Link>
      </div>
    </div>
  );
};

const LoadingSkeleton = () => {
  return (
    <div className="bg-white rounded-xl overflow-hidden">
      <Skeleton className="h-[103px] w-full rounded-none" />

      <div className="px-[15px] pt-2.5 pb-5 flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <Skeleton className="h-6 w-14" />
          <Skeleton className="h-6 w-32" />
        </div>
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-16 w-full" />
        <div className="flex justify-between items-center">
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-20" />
        </div>
      </div>
    </div>
  );
};
